export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'yule-baoliao',
    name: '娱乐爆料',
    description: '娱乐圈最新内幕、明星八卦、影视幕后独家揭秘',
    icon: 'ri-movie-line',
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    description: '社会民生热点事件深度追踪与独家内幕',
    icon: 'ri-fire-line',
  },
  {
    slug: 'shangye-miwen',
    name: '商业秘闻',
    description: '商业巨头决策内幕、行业黑幕、资本博弈',
    icon: 'ri-briefcase-line',
  },
  {
    slug: 'keji-neimu',
    name: '科技内幕',
    description: '科技巨头内部消息、产品秘密、行业变革',
    icon: 'ri-cpu-line',
  },
  {
    slug: 'guoji-baoliao',
    name: '国际爆料',
    description: '国际大事背后的隐秘真相与独家解读',
    icon: 'ri-global-line',
  },
  {
    slug: 'niming-tougao',
    name: '匿名投稿',
    description: '来自知情人士的匿名爆料，还原事件真相',
    icon: 'ri-shield-user-line',
  },
];

export const categoryMap: Record<string, Category> = categories.reduce(
  (acc, cat) => ({ ...acc, [cat.slug]: cat }),
  {} as Record<string, Category>,
);